import { TAXONOMY_LEVELS } from './taxonomy';

/**
 * Finds the taxonomy path for a given category by looking up its parent in the taxonomy structure
 * @param category The category to find the path for
 * @returns The full path in the format '/parent/category' or null if not found
 */
export const findTaxonomyPath = (category: string): string | null => {
  // Normalize the category to match the format in taxonomy
  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '-');

  // Search through each parent category in the taxonomy
  for (const [parent, children] of Object.entries(TAXONOMY_LEVELS)) {
    if (children.includes(normalizedCategory)) {
      return `/${parent}/${normalizedCategory}`;
    }
  }

  // If the category is a parent itself, return just the category
  if (normalizedCategory in TAXONOMY_LEVELS) {
    return `/${normalizedCategory}`;
  }

  return null;
};
